import React, { useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import toastr from "toastr";
import { cnpjMask } from '../../../shared/mask';

function PropertyForm({ onSubmit, initialData, onSubmitAttachment, errors }) {

  const [formData, setFormData] = useState({
    ownership: {
      isOwProperty: initialData && initialData.ownership && initialData.ownership.isOwProperty ? initialData.ownership.isOwProperty : null,
      rentFromThirdParty: initialData && initialData.ownership && initialData.ownership.rentFromThirdParty ? initialData.ownership.rentFromThirdParty : false,
      rentToThirdParty: initialData && initialData.ownership && initialData.ownership.rentToThirdParty ? initialData.ownership.rentToThirdParty : false
    }
  });

  const [fileData, setFileData] = useState();
  const [hasElaw, setHasElaw] = useState(initialData && initialData.elaw && initialData.elaw !== '' ? true : false);

  useEffect(() => {
    // if (initialData && Object.keys(initialData).length == 1) {
    setFormData(initialData);
    // }
  }, []);

  useEffect(() => {
    if (formData) {
      handleSubmit();
    }
  }, [formData]);

  useEffect(() => {
    if (fileData) {
      onSubmitAttachment(fileData, true);
    }
  }, [fileData]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (errors.indexOf(name) > -1) {
      errors.splice(errors.indexOf(name) , 1);
    }

  };

  const handleOwnerShipChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ownership: {
        ...prevData.ownership,
        [name]: str2bool(value)
      }

    }));


  };

  const handleFileChange = (e) => {
    const { files } = e.target;

    if (files.length === 0) { 
      return;
    }
    const allowedTypes = ["kml"];
    if (!allowedTypes.includes(files[0].name.split('.').pop())) {
      toastr.error("O arquivo deve ser um KML");
      e.target.value = "";
      return;
    }
    

    setFormData((prevData) => ({
      ...prevData,
      kml: files[0].name,
    }));

    if (errors.indexOf('kml') > -1) {
      errors.splice(errors.indexOf('kml') , 1);
    }

    setFileData(files[0]);

  };

  const handleSubmit = () => {
    // e.preventDefault();
    onSubmit(formData, 'root');
  };

  const handleChangeHasElaw = (e) => {
    const { name, value } = e.target;
    setHasElaw(e.target.checked);
    if (e.target.checked) {
      setFormData((prevData) => ({...prevData, 'elaw': prevData.elaw && prevData.elaw !=='' ? prevData.elaw : '' }));
    } else {
      setFormData((prevData) => ({ ...prevData, 'elaw': null }));
    }
    handleSubmit();
  }

  const str2bool = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  }

  return (
    <Form>
      <Row>
        <Col md={6}>
          <h5 style={{ width: '50%' }}>Preencha os dados da propriedade</h5>
          <Form.Group className='mt-3'>
            <Form.Label>KML: {formData.kml && formData.kml !== '' ? `Arquivo anexado = ${formData.kml}` : '*' }</Form.Label>
            <Form.Control
              type="file"
              id="customFile"
              label="Escolher Arquivo"
              accept='application/kml'
              onChange={handleFileChange}
            />
          </Form.Group>
          {errors?.length > 0 && errors.indexOf('kml') > -1 && <span className='mb-2 block text-sm font-medium text-red-700'>Campo obrigatório</span>}
          <Form.Group className='mt-3'>
            <Form.Label>Nome (Exibiçao da lista) *</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nome para mostrar na lista de propriedades"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.length > 0 && errors.indexOf('title') > -1 && <span className='mb-2 block text-sm font-medium text-red-700'>Campo obrigatório</span>}
          <Form.Group className='mt-3'>
            <Form.Label>Nome completo da Propriedade *</Form.Label>
            <Form.Control
              type="textarea"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.length > 0 && errors.indexOf('name') > -1 && <span className='mb-2 block text-sm font-medium text-red-700'>Campo obrigatório</span>}
          <Form.Group className='mt-3'>
            <Form.Label>CNPJ (somente número) *</Form.Label>
            <Form.Control
              type="textarea"
              name="cnpj"
              value={cnpjMask(formData.cnpj)}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.length > 0 && errors.indexOf('cnpj') > -1 && <span className='mb-2 block text-sm font-medium text-red-700'>Campo obrigatório</span>}
          <Form.Group className='mt-3'>
            <Form.Label>Coordenadas (exibição na lista) *</Form.Label>
            <Form.Control
              type="text"
              name="coords"
              value={formData.coords}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.length > 0 && errors.indexOf('coords') > -1 && <span className='mb-2 block text-sm font-medium text-red-700'>Campo obrigatório</span>}
          <Form.Check className='mt-3' // prettier-ignore
            type="checkbox"
            label="Existem Procedimentos nesse imóvel"
            name="hasProcedure"
            defaultChecked={initialData && initialData.elaw && initialData.elaw !== '' ? true : false}
            onChange={handleChangeHasElaw}
          />
          {hasElaw && 
            <>
              <Form.Group className='mt-3'>
                <Form.Label>Sistema Jurídico: *</Form.Label>
                <Form.Control
                  type="textarea"
                  name="elaw"
                  value={formData.elaw}
                  onChange={handleChange}
                />
              </Form.Group>
              {errors?.length > 0 && errors.indexOf('elaw') > -1 && <span className='mb-2 block text-sm font-medium text-red-700'>Campo obrigatório</span>}
            </>
          }
        </Col>
        <Col md={6}>
          
          <h6 style={{ width: '60%' }} className='mt-4'>Titularidade</h6>
          <label className="form-label mt-3">O imóvel é próprio?</label><br />
          <Form.Check className='mt-3' // prettier-ignore
            inline
            type="radio"
            label="Sim"
            name="isOwProperty"
            onChange={handleOwnerShipChange}
            defaultChecked={formData.ownership && formData.ownership.isOwProperty && formData.ownership.isOwProperty ? formData.ownership.isOwProperty : false} // prettier-ignore
            value={true}
          />
          <Form.Check className='mt-3' // prettier-ignore
            inline
            type="radio"
            label="Não"
            name="isOwProperty"
            onChange={handleOwnerShipChange}
            defaultChecked={false} // prettier-ignore
            value={false}
          />
          <br />

          {formData.ownership && formData.ownership.isOwProperty != null && !formData.ownership.isOwProperty ?
            <>
              <br />
              <label className="form-label mt-3">Arrendo o imóvel de terceiros?</label><br />
              <Form.Check className='mt-3' // prettier-ignore
                inline
                type="radio"
                label="Sim"
                name="rentFromThirdParty"
                onChange={handleOwnerShipChange}
                defaultChecked={formData.ownership.rentFromThirdParty === true} // prettier-ignore
                value={true}
              />
              <Form.Check className='mt-3' // prettier-ignore
                inline
                type="radio"
                label="Não"
                name="rentFromThirdParty"
                onChange={handleOwnerShipChange}
                defaultChecked={formData.ownership.rentFromThirdParty === false} // prettier-ignore
                value={false}
              />
            </>
            : ''}
          {formData.ownership && formData.ownership.isOwProperty != null && formData.ownership.isOwProperty ?
            <>
              <br />
              <label className="form-label mt-3">Arrendo o imóvel para terceiros?</label><br />
              <Form.Check className='mt-3' // prettier-ignore
                inline
                type="radio"
                label="Sim"
                name="rentToThirdParty"
                onChange={handleOwnerShipChange}
                defaultChecked={formData.ownership.rentToThirdParty === true}
                value={true}
              />
              <Form.Check className='mt-3' // prettier-ignore
                inline
                type="radio"
                label="Não"
                name="rentToThirdParty"
                onChange={handleOwnerShipChange}
                defaultChecked={formData.ownership.rentToThirdParty === false}
                value={false}
              />
            </>
            : ''}



        </Col>
      </Row>

    </Form>
  );
}

export default PropertyForm;
